import React from 'react';
import PropTypes from 'prop-types';

type TextAreaInputType = {
  data: {
    placeholder: string;
    type: string;
    value: string;
    disabled?: boolean;
    name: string;
    rows?: number;
  },
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextAreaInput = ({data, onChange}: TextAreaInputType) => {
  return (
    <textarea 
      rows={data.rows}
      name={data.name ? data.name : ''} 
      placeholder={data.placeholder} 
      autoComplete='off'
      className='tw-w-full tw-border-[1px] tw-border-light-green tw-rounded-xl tw-px-3 tw-py-2 focus:tw-outline-none disabled:tw-bg-[#d1d1d16b]'
      onChange={onChange} 
      value={`${data.value}`}
      disabled={data.disabled}
    />
  )
}

TextAreaInput.propTypes = {
  data: PropTypes.object,
};

TextAreaInput.defaultProps = {
  data: {
    title: '',
    placeholder: '',
    type: '',
    onChange: () => {},
    value: '',
    disabled: false
  }
};

export default TextAreaInput;